<template>
  <div>
    <datatable
      title="Meetings"
      @create="createMeeting"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-meetings',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'timing',
          value: 'timing',
          is_time: true
        },
        {
          name: 'history_company',
          value: 'history_company.name'
        },
        {
          name: 'applicant_message',
          value: 'applicant_message'
        },
        {
          name: 'company_message',
          value: 'company_message'
        },
        {
          name: 'company',
          component_data_path: 'company',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Company'
          }
        },
        {
          name: 'applicant',
          component_data_path: 'applicant',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Applicant'
          }
        },
        {
          name: 'requested_interview_preparation',
          value: 'requested_interview_preparation'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.$network_utils.getAllMeetings({ sort: '-timing' }).then(response => {
      this.data = response
    })
  },
  methods: {
    createMeeting () {
      this.create({ designator: 'admin-meeting-form-modal', component_name: 'AdminMeetingForm', is_create: true, modal_title: 'Create new Meeting' })
    },
    editClick (data) {
      this.create({ designator: 'admin-meeting-form-modal', component_name: 'AdminMeetingForm', data, modal_title: data.history_company.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
